/* NEW: UI_REVAMP */
import dayjs from 'dayjs';

export const MAX_FILTER_DATE_RANGE_DAYS = 90;

export const getConfirmedCalendarDateRange = ({
	draftDateRange = [],
	selected,
	maxRangeDays = MAX_FILTER_DATE_RANGE_DAYS,
}) => {
	const fallbackDate = selected || new Date();
	const startDate = draftDateRange[0] || fallbackDate;
	const endDate = draftDateRange[1] || startDate;
	const selectedRangeDays = dayjs(endDate)
		.startOf('day')
		.diff(dayjs(startDate).startOf('day'), 'day');
	const limitedEndDate =
		selectedRangeDays > maxRangeDays
			? dayjs(startDate).add(maxRangeDays, 'day').toDate()
			: endDate;

	return [startDate, limitedEndDate];
};

export const createCalendarConfirmHandler = ({
	draftDateRange,
	selected,
	setChildDateRange,
	setDraftDateRange,
	setIsCalendarView,
}) => {
	return () => {
		const nextDateRange = getConfirmedCalendarDateRange({ draftDateRange, selected });

		setChildDateRange(nextDateRange);
		setDraftDateRange(nextDateRange);
		setIsCalendarView(false);
	};
};
